// Case: Round Photo Cake: Conditional Rules for flavor options
// Matching flavor options it to Size-OT (handle: 344cf24f4b2f11b35daa2cbda1f363e9) - value: 1de90ee3c8a9bd7a0abc1a560afaf753-2

const CONDITIONAL_RULES = {
  "9515797217594": [
    {
      when: {
        optionTemplateHandle: "344cf24f4b2f11b35daa2cbda1f363e9",
        valueHandle: "1de90ee3c8a9bd7a0abc1a560afaf753-2",
      },
      then: {
        disable: [
          {
            optionTemplateHandle: "geschmack-standard-inkl-muffincakes",
            valueHandle: "geschmack-muffinkuchen-mit-sprinkles",
          },
        ],
      },
    },
    {
      when: {
        optionTemplateHandle: "geschmack-standard-inkl-muffincakes",
        valueHandle: "geschmack-muffinkuchen-mit-sprinkles",
      },
      then: {
        disable: [
          {
            optionTemplateHandle: "344cf24f4b2f11b35daa2cbda1f363e9",
            valueHandle: "1de90ee3c8a9bd7a0abc1a560afaf753-2",
          },
        ],
      },
    },
    {
      when: {
        optionTemplateHandle: "344cf24f4b2f11b35daa2cbda1f363e9",
        valueHandle: "1de90ee3c8a9bd7a0abc1a560afaf753-2",
      },
      then: {
        disable: [
          {
            optionTemplateHandle: "geschmack-standard-inkl-muffincakes",
            valueHandle: "geschmack-zitronen-muffinkuchen-mit-lemon-curd",
          },
        ],
      },
    },
    {
      when: {
        optionTemplateHandle: "geschmack-standard-inkl-muffincakes",
        valueHandle: "geschmack-zitronen-muffinkuchen-mit-lemon-curd",
      },
      then: {
        disable: [
          {
            optionTemplateHandle: "344cf24f4b2f11b35daa2cbda1f363e9",
            valueHandle: "1de90ee3c8a9bd7a0abc1a560afaf753-2",
          },
        ],
      },
    },
    {
      when: {
        optionTemplateHandle: "344cf24f4b2f11b35daa2cbda1f363e9",
        valueHandle: "1de90ee3c8a9bd7a0abc1a560afaf753-2",
      },
      then: {
        disable: [
          {
            optionTemplateHandle: "geschmack-standard-inkl-muffincakes",
            valueHandle: "geschmack-schoko-muffinkuchen-mit-nougat",
          },
        ],
      },
    },
    {
      when: {
        optionTemplateHandle: "geschmack-standard-inkl-muffincakes",
        valueHandle: "geschmack-schoko-muffinkuchen-mit-nougat",
      },
      then: {
        disable: [
          {
            optionTemplateHandle: "344cf24f4b2f11b35daa2cbda1f363e9",
            valueHandle: "1de90ee3c8a9bd7a0abc1a560afaf753-2",
          },
        ],
      },
    },
  ],
};

let isApplyingRules = false;

/**
 * Apply conditional rules based on product handle
 */
function applyConditionalRules(changedInput) {
  if (isApplyingRules) return;
  isApplyingRules = true;

  try {
    // Check if rules exist for current product
    const rules = CONDITIONAL_RULES[CURRENT_PRODUCT_ID];
    if (!rules) return;

    resetAllDisabledOptions();

    const allOptionTemplates = document.querySelectorAll(
      "[data-dt-opt-handle]",
    );
    const currentlySelected = []; // { optTemplateHandle, valHandle } for all currently selected options

    allOptionTemplates.forEach((template) => {
      const checkedInput = template.querySelector(
        "input[data-dt-optval-handle]:checked",
      );
      if (checkedInput) {
        const optTemplateHandle = template.getAttribute("data-dt-opt-handle");
        const valHandle = checkedInput.getAttribute("data-dt-optval-handle");
        currentlySelected.push({ optTemplateHandle, valHandle });
      }
    });

    const activeRules = [];
    rules.forEach((rule) => {
      const isActive = currentlySelected.some(
        (selected) =>
          selected.optTemplateHandle === rule.when.optionTemplateHandle &&
          selected.valHandle === rule.when.valueHandle,
      );
      if (isActive) {
        activeRules.push(rule);
      }
    });

    // Apply all active rules
    activeRules.forEach((rule) => {
      rule.then.disable.forEach((disableConfig) => {
        disableOption(
          disableConfig.optionTemplateHandle,
          disableConfig.valueHandle,
        );
      });
    });
  } catch (error) {
    console.error("Error applying conditional rules:", error);
  } finally {
    isApplyingRules = false;
  }
}

function disableOption(optionTemplateHandle, valueHandle) {
  const optionTemplate = document.querySelector(
    `[data-dt-opt-handle="${optionTemplateHandle}"]`,
  );
  if (!optionTemplate) {
    console.warn(`Option template not found: ${optionTemplateHandle}`);
    return;
  }

  const optionToDeactivate = optionTemplate.querySelector(
    `input[data-dt-optval-handle="${valueHandle}"]`,
  );
  if (!optionToDeactivate) {
    console.warn(
      `Option value not found: ${valueHandle} in ${optionTemplateHandle}`,
    );
    return;
  }

  const targetOptionItem = optionToDeactivate.closest(".option-item");
  if (!targetOptionItem) return;

  targetOptionItem.setAttribute("data-disabled", "true");
  optionToDeactivate.disabled = true;

  // For one-directional rules: If this option was selected, uncheck it and select an alternative
  if (optionToDeactivate.checked) {
    optionToDeactivate.checked = false;
    // Find and select the first available (non-disabled) option
    const allOptionsInTemplate = optionTemplate.querySelectorAll(
      "input[data-dt-optval-handle]",
    );
    const firstAvailable = Array.from(allOptionsInTemplate).find((input) => {
      const optionItem = input.closest(".option-item");
      return !optionItem.hasAttribute("data-disabled");
    });

    if (firstAvailable) {
      firstAvailable.checked = true;
      firstAvailable.dispatchEvent(new Event("change", { bubbles: true }));

      // Scroll to the newly selected option
      const selectedOptionItem = firstAvailable.closest(".option-item");
      selectedOptionItem?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }
}

/**
 * Reset all disabled states
 */
function resetAllDisabledOptions() {
  const allDisabledOptionItems = document.querySelectorAll(
    '.option-item[data-disabled="true"]',
  );
  allDisabledOptionItems.forEach((optionItem) => {
    optionItem.removeAttribute("data-disabled");
    const input = optionItem.querySelector("input");
    if (input) input.disabled = false;
  });
}
